module.exports = __webpack_public_path__ + "img/ptclogo.1a9b6319.png";